import { Link, useHistory } from 'react-router-dom';
import './Success.css'; // Import your CSS file
import { useGlobalStore } from './stateManagement/globalZustand';
import { _defaultButtonColor, _dict } from './constants';
import { IonButton } from '@ionic/react';

const SuccessPage = () => {
    const { lang } = useGlobalStore();
    const history = useHistory();
  return (
    <div className="success-page">
      <h1>🟢 {_dict.paymentSuccess[lang]}</h1>
      <br/>
      <p>{_dict.updatesMayTakeAWhile[lang]}</p>
      <br/>
      
      <br/>
      <IonButton style={{"--background":_defaultButtonColor}} onClick={() => history.push("/login")}>{_dict.understood[lang]}</IonButton>
    </div>
  );
};

export default SuccessPage;
